import styled from 'styled-components';

export interface TagProps {
  size?: 'small' | 'medium';
  color?: string;
  onClick?: () => void;
}

const Tag = styled.span<TagProps>`
  border-radius: 3px;
  border: 1px solid currentColor;
  color: ${({ color }) => color};
  display: inline-block;
  font-family: ${({ theme }) => theme.fontFamily || `Quicksand, sans-serif`};
  font-size: ${({ size }) => (size === 'small' ? '10px' : '12px')};
  font-weight: ${({ size, theme }) => (size === 'small' ? '700' : theme.fontWeight || '600')};
  line-height: 12px;
  padding: ${({ size }) => (size === 'small' ? '2px' : '6px')} 5px;
  margin: 0 ${({ size }) => (size === 'small' ? '5px' : '15px')} 5px 0;
`;

export default Tag;
